import { graphql } from '@repo/api-kit/graphql';
import type { SearchOrganizationQuery } from '@repo/api-kit/graphql/types';
import { graphQLClient } from '#utils/graphql-client';

const gqlQuery = graphql(`
  query searchOrganizationSlug {
    searchOrganization {
      organization {
        slug
      }
    }
  }
`);

/**
 * Fetches only the current organization's slug.
 */
export async function searchOrganizationSlug(
  organizationId: string
): Promise<SearchOrganizationQuery['searchOrganization']['organization']['slug']> {
  const result = await graphQLClient(
    gqlQuery,
    {},
    {
      requestHeaders: {
        'X-Qonto-Organization-Id': organizationId,
      },
    }
  );

  return result.searchOrganization.organization.slug;
}
